import { PropertyOwnerPermissionType } from 'models/Owner';
import * as Yup from 'yup';

export const formSchema = Yup.object({
  uid: Yup.string().required(),
  [PropertyOwnerPermissionType.READING_CALENDAR]: Yup.boolean(),
  [PropertyOwnerPermissionType.READING_BOOKING_DETAILS]: Yup.boolean(),
  [PropertyOwnerPermissionType.READING_BOOKING_VALUE]: Yup.boolean(),
  [PropertyOwnerPermissionType.CREATING_BLOCKS]: Yup.boolean(),
});

export type OwnerPermissionsFormSchemaType = Yup.InferType<typeof formSchema>;
